import React from 'react';
import PropTypes from 'prop-types';
import TableWithSummary from '../TableWithSummary/TableWithSummary';
import { TextWithTooltipIcon } from '@components';
import { calculateDifferenceInPercentage } from '@helpers';
import { EU_ALLOWANCE_FOR_MY_CARGO, ETS_COST_PER_TONNE } from '@constants/tooltips';
import { formatNumberReadable, formatToDecimalPlaces } from '@helpers';

const MyCargoEstimatedETSTable = ({
  myCargoEuEtsAllowanceSummary,
  alternativeDataSource,
  isLoading
}) => {
  const columns = [
    { name: 'items', label: 'Items' },
    { name: 'amount', label: 'Amount' }
  ];

  const createTableData = () => {
    if (!myCargoEuEtsAllowanceSummary) return [];

    return [
      {
        items: {
          value: 'My Cargo (MT)',
          tooltip:
            'Click on the ‘Modify’ button on the top to input your cargo weight and generate results corresponding to your cargo weight in your own customized calculation which is only visible to the you. '
        },
        amount: {
          value: formatNumberReadable(
            formatToDecimalPlaces(myCargoEuEtsAllowanceSummary.myCargoWeightTn, 1)
          ),
          isEditable: false
        }
      },
      {
        items: {
          value: 'ETS cost per tonne CO₂(€)',
          tooltip: ETS_COST_PER_TONNE
        },
        amount: {
          value: formatNumberReadable(
            formatToDecimalPlaces(myCargoEuEtsAllowanceSummary.etsCostPerCo2, 2)
          ),
          isEditable: false
        }
      },
      {
        items: { value: 'ETS cost for my cargo (€)' },
        amount: {
          value: formatNumberReadable(
            formatToDecimalPlaces(myCargoEuEtsAllowanceSummary.totalMyCargoEstimatedEuEtsCost, 0)
          )
        }
      },
      {
        items: { value: 'EU Allowances for my cargo', tooltip: EU_ALLOWANCE_FOR_MY_CARGO },
        amount: {
          value: formatNumberReadable(
            formatToDecimalPlaces(myCargoEuEtsAllowanceSummary.totalMyCargoEuEtsAllowanceTn, 0)
          )
        }
      }
    ];
  };

  const createSummary = () => {
    if (!myCargoEuEtsAllowanceSummary) return [];

    return [
      {
        label: 'EU ETS Cost for my cargo (€)',
        value: formatNumberReadable(
          formatToDecimalPlaces(myCargoEuEtsAllowanceSummary?.totalMyCargoEstimatedEuEtsCost, 0)
        ),
        difference: alternativeDataSource
          ? calculateDifferenceInPercentage(
              myCargoEuEtsAllowanceSummary?.totalMyCargoEstimatedEuEtsCost,
              alternativeDataSource?.totalMyCargoEstimatedEuEtsCost
            )
          : 0
      },
      {
        label: (
          <TextWithTooltipIcon
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.1em'
            }}
            label="EU Allowances for my cargo"
            tooltipText={EU_ALLOWANCE_FOR_MY_CARGO}
          />
        ),
        value: formatNumberReadable(
          formatToDecimalPlaces(myCargoEuEtsAllowanceSummary?.totalMyCargoEuEtsAllowanceTn, 0)
        ),
        difference: alternativeDataSource
          ? calculateDifferenceInPercentage(
              myCargoEuEtsAllowanceSummary?.totalMyCargoEuEtsAllowanceTn,
              alternativeDataSource?.totalMyCargoEuEtsAllowanceTn
            )
          : 0
      }
    ];
  };

  return (
    <TableWithSummary
      title="My cargo"
      columns={columns}
      data={createTableData()}
      summary={createSummary()}
      isLoading={isLoading}
      id="my-cargo-ets-table"
    />
  );
};

MyCargoEstimatedETSTable.propTypes = {
  myCargoEuEtsAllowanceSummary: PropTypes.object,
  alternativeDataSource: PropTypes.object,
  isLoading: PropTypes.bool,
  voyagePortCalls: PropTypes.array,
  mainEngineFuel: PropTypes.array
};

export default MyCargoEstimatedETSTable;
